import { combineReducers, configureStore } from '@reduxjs/toolkit';
import checkTokenReducer from './app/checkToken/checkToken.slice';
import setApiErrorReducer from './app/setApiError/setApiError.slice';
import setAppMountedReducer from './app/setAppMounted/setAppMounted.slice';
import setMeReducer from './app/setMe/setMe.slice';
import setPathnameReducer from './app/setPathname/setPathname.slice';
import forgotPasswordReducer from './auth/forgotpassword/forgotpassword.slice';
import loginReducer from './auth/login/login.slice';
import logoutReducer from './auth/logout/logout.slice';
import newPasswordReducer from './auth/newpassword/newpassword.slice';
import setRemoteConfigReducer from './firebase/setRemoteConfig/setRemoteConfig.slice';
import getCaseFeedbackSlice from './hedefnet/feedBack/getCaseFeedback.slice';
import getFeedbackSlice from './hedefnet/feedBack/getFeedback.slice';
import getDemandsSlice from './hedefnet/getDemands/getDemands.slice';
import getExtractSlice from './hedefnet/getFinancial/getExtract.slice';
import getFinancialSlice from './hedefnet/getFinancial/getFinancial.slice';
import getDocumentContractSlice from './hedefnet/getFleetCar/getDocumentContract/getDocumentContract.slice';
import getFineListSlice from './hedefnet/getFleetCar/getFineList/getFineList.slice';
import getFleetCarSlice from './hedefnet/getFleetCar/getFleetCar.slice';
import getFleetContratProtocolSlice from './hedefnet/getFleetCar/getFleetContratProtocol/getFleetContratProtocol.slice';
import getFleetDeliverySlice from './hedefnet/getFleetCar/getFleetDelivery/getFleetDelivery.slice';
import getHgsSlice from './hedefnet/getFleetCar/getHgs.slice';
import getReturnCarSlice from './hedefnet/getFleetCar/getReturnCar/getReturnCar.slice';
import getSecondHandSlice from './hedefnet/getFleetCar/getSecondHand/getSecondHand.slice';
import getInvoicesSlice from './hedefnet/getInvoices/getInvoices.slice';
import getProcessualDemandsSlice from './hedefnet/getProcessualDemands/getProcessualDemands.slice';
import getServicesSlice from './hedefnet/getServices/getServices.slice';
import getSubCompaniesReducer from './hedefnet/getSubCompanies/getSubCompanies.slice';
import getTableColumnsSlice from './hedefnet/getTableColumns/getTableColumns.slice';
import invoicesSlice from './hedefnet/invoices/invoices.slice';
import subCompanySelectReducer from './hedefnet/subCompanySelect/subCompanySelect.slice';
import tableSlice, { listenerMiddleware } from './table/table.slice';
import getMeReducer from './user/getMe/getMe.slice';
import getUsersSlice from './user/getUsers/getUsers.slice';
import getTireStorageSlice from './hedefnet/getTireStorage/getTireStorage.slice';
import getTireRightsSlice from './hedefnet/getTireRights/getTireRights.slice';
import getInvoicePaymentSlice from './hedefnet/getPaymentSlice/getInvoicePayment.slice';
import getInvoicesProblemSlice from './hedefnet/getInvoices/getProblemInvoices.slice';
import getFleetUTTSListSlice from './hedefnet/getFleetCar/getFleetUTTSList/getFleetUTTSList.slice';
import listAllNotificationSlice from './userNotification/userNotification.slice';
import getOverdueInvoicesSlice from './hedefnet/getInvoices/getOverdueInvoices.slice';
import getNotificationSlice from './hedefnet/getCampaign/getNotification/getNotification.slice';
import getUserListSlice from './hedefnet/getCampaign/getUserList/getUserList.slice';
import getCampaingSlice from './hedefnet/getCampaign/getCampaing.slice';
import getFleetGPSListSlice from './hedefnet/getFleetCar/getFleetGPSList/getFleetGPSList.slice';
import getMaintenancePeriodsSlice from './hedefnet/getMaintenancePeriods/getMaintenancePeriods.slice';

const appReducer = combineReducers({
  checkToken: checkTokenReducer,
  setApiError: setApiErrorReducer,
  setAppMounted: setAppMountedReducer,
  setMe: setMeReducer,
  setPathname: setPathnameReducer,
});

const authReducer = combineReducers({
  login: loginReducer,
  logout: logoutReducer,
  newPassword: newPasswordReducer,
  forgotPassword: forgotPasswordReducer,
});

const firebaseReducer = combineReducers({
  setRemoteConfig: setRemoteConfigReducer,
});

const hedefnetReducer = combineReducers({
  getSubCompanies: getSubCompaniesReducer,
  subCompanySelect: subCompanySelectReducer,
  getTableColumns: getTableColumnsSlice,
  getInvoices: getInvoicesSlice,
  getProblemInvoices: getInvoicesProblemSlice,
  invoices: invoicesSlice,
  getServices: getServicesSlice,
  getFinancial: getFinancialSlice,
  getInvoicePayment: getInvoicePaymentSlice,
  getExtract: getExtractSlice,
  getFleetCar: getFleetCarSlice,
  getFleetUTTSList: getFleetUTTSListSlice,
  getFleetGPSList: getFleetGPSListSlice,
  getHgs: getHgsSlice,
  getSecondHand: getSecondHandSlice,
  getFineList: getFineListSlice,
  getContratProtocol: getFleetContratProtocolSlice,
  getReturnCar: getReturnCarSlice,
  getDocumentContract: getDocumentContractSlice,
  getFleetDelivery: getFleetDeliverySlice,
  getProcessualDemands: getProcessualDemandsSlice,
  getDemands: getDemandsSlice,
  getFeedback: getFeedbackSlice,
  getCaseFeedback: getCaseFeedbackSlice,
  table: tableSlice,
  getTireStorage: getTireStorageSlice,
  getTireRights: getTireRightsSlice,
  getOverdueInvoices: getOverdueInvoicesSlice,
  getNotification: getNotificationSlice,
  getUserList: getUserListSlice,
  getCampaing: getCampaingSlice,
  getMaintenancePeriods: getMaintenancePeriodsSlice,
});

const userReducer = combineReducers({
  getMe: getMeReducer,
  getUsers: getUsersSlice,
});

const notificationReducer = combineReducers({
  listAll: listAllNotificationSlice,
});

const store = configureStore({
  reducer: {
    app: appReducer,
    auth: authReducer,
    firebase: firebaseReducer,
    hedefnet: hedefnetReducer,
    user: userReducer,
    notification: notificationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['tableSlice/setColumns'],
      },
    }).prepend(listenerMiddleware.middleware),
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
